<template>
    <div>
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
                <b-col lg="12" cols="12">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{ language_terms[$route.name] }}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb />
                </nav>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <loading :active.sync="loading" 
                color= '#007bff'
                :width= '128'
                :height= '128'
                loader='dots'
                :can-cancel="true" 
                :is-full-page="true">
            </loading>
            <b-row>
                <b-col lg="12">
                    <b-card>
                        <div slot="header" class="mb-0">
                            <b-row>
                                <b-col cols="12">
                                    <span style="font-weight: bold">{{ language_terms['NEW'] }} {{ language_terms['INVOICE'] }}</span>
                                </b-col>
                            </b-row>
                        </div>
                        <b-row>
                            <b-col cols="12">
                                <b-row>
                                    <b-col :md="business_units.length > 1 ? 4 : 6">
                                    <label class="form-control-label">{{language_terms["CUSTOMER"]}}</label>
                                        <multiselect
                                            :internalSearch = "false"
                                            v-model="invoice.customer"
                                            id="ajax"
                                            label="name"
                                            track-by="id"
                                            placeholder="Type to search"
                                            open-direction="bottom"
                                            :options="customers"
                                            :multiple="false"
                                            :searchable="true"
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :options-limit="300"
                                            :limit="50"
                                            :max-height="600"
                                            :show-no-results="false"
                                            :hide-selected="false"
                                            @search-change="asyncFindCustomer"
                                            @input="onSelectCustomer"
                                            >
                                        </multiselect>
                                </b-col>
                                <b-col md="4" v-if="business_units.length > 1">
                                    <base-input :label="language_terms['BUSINESS_UNIT']">
                                        <el-select
                                            v-model="invoice.businessunit_contact_id"
                                            filterable
                                            :placeholder="language_terms['BUSINESS_UNIT']"
                                        >
                                        <el-option
                                            v-for="option in business_units"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id">
                                        </el-option>
                                        </el-select>
                                    </base-input>
                                </b-col>
                                <b-col :md="business_units.length > 1 ? 3 : 5">
                                    <base-input :label="language_terms['DATE']">
                                        <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        @on-change="onChangeDate"
                                        style="background-color: white"
                                        class="form-control datepicker"
                                        v-model="invoice.date">
                                        </flat-picker>
                                    </base-input>
                                </b-col>
                                <b-col md="1" class="mt-4">
                                    <base-button icon type="success"  @click="listDo" class="mt-2">
                                        {{language_terms['LIST_DO']}}
                                    </base-button>
                                </b-col>
                                </b-row>
                                <b-row  v-if="do_list.length > 0">
                                    <b-col cols="12">
                                        <b-table :items="do_list" :fields="fields">
                                            <template #head(is_selected)>
                                                <b-form-checkbox v-model="select_all" name="checkbox-all" value="1" unchecked-value="0" @change="onClickSelectAll"></b-form-checkbox>
                                            </template>
                                            <template #cell(is_selected)="row">
                                                <b-form-checkbox v-model="row.item.is_selected" name="checkbox-1" value="1" unchecked-value="0"></b-form-checkbox>
                                            </template>
                                            <template #cell(salesperson_contact_id)="row">
                                                <el-select
                                                    v-model="row.item.salesperson_contact_id"
                                                    filterable
                                                    :placeholder="language_terms['SALESPERSON']">
                                                    <el-option
                                                        v-for="option in row.item.salesperson_list"
                                                        :key="option.id"
                                                        :label="option.name"
                                                        :value="option.id">
                                                    </el-option>
                                                </el-select>
                                            </template>
                                            <template #cell(actionsBtn) ="row">
                                                <base-button @click="row.toggleDetails" size="sm" icon type="success" class="float-right mr-2">
                                                    <i :class="row.detailsShowing ? 'fa fa-angle-up' : 'fa fa-angle-down'"></i>
                                                </base-button>
                                            </template>
                                            <template #row-details="row">
                                                <b-card>
                                                    <div slot="header">
                                                        <b-row>
                                                            <b-col cols="12">
                                                                {{language_terms['DO_ITEMS']}}
                                                            </b-col>
                                                        </b-row>
                                                    </div>
                                                    <b-row>
                                                        <b-col cols="12">
                                                            <b-table-simple hover striped>
                                                                <b-thead>
                                                                    <b-tr>
                                                                        <b-th>{{language_terms['SNO']}}</b-th>
                                                                        <b-th>{{language_terms['PRODUCT_CODE']}}</b-th>
                                                                        <b-th>{{language_terms['PRODUCT_NAME']}}</b-th>
                                                                        <b-th>{{language_terms['REFERENCE_DOCUMENT']}}</b-th>
                                                                        <b-th>{{language_terms['QTY']}}</b-th>
                                                                        <b-th>{{language_terms['UNIT_PRICE']}}</b-th>
                                                                    </b-tr>
                                                                </b-thead>
                                                                <b-tbody>
                                                                    <b-tr v-for="(item, index) in row.item.items" :key="index">
                                                                        <td>{{index + 1}}</td>
                                                                        <td>{{item.product_code}}</td>
                                                                        <td>{{item.product_name}}</td>
                                                                        <td>{{item.reference_document_code}}</td>
                                                                        <td>{{item.qty}}</td>
                                                                        <td>{{item.unit_price}}</td>
                                                                    </b-tr>
                                                                </b-tbody>
                                                            </b-table-simple>
                                                        </b-col>
                                                    </b-row>
                                                </b-card>
                                        </template>
                                        </b-table>
                                    </b-col>
                                </b-row>

                            </b-col>


                        </b-row>
                        <b-row class="mt-4" v-if="do_list.length > 0">
                            <b-col cols="12" class="mb-4">
                                <span v-if="selectedCount > 0">{{language_terms['SELECTED_DOS']}} - <span class="text-green text-bold font-weight-bold">{{selectedCount}}</span></span> 
                            </b-col>
                            <b-col cols="12">
                                <b-button variant="primary" @click="generateInvoice">
                                    {{language_terms['GENERATE_INVOICE']}}
                                </b-button>
                            </b-col>
                        </b-row>

                    </b-card>
                </b-col>
            </b-row>
            <b-modal v-model="generate_si_modal" :title="language_terms['GENERATED_SIS']" centered  no-close-on-backdrop hide-header-close>
                <b-row>
                    <b-col cols="12">
                        <b-table-simple hover striped>
                            <b-thead head-variant="light">
                                <b-th>{{language_terms['SNO']}}</b-th>
                                <b-th>{{language_terms['INVOICE']}}</b-th>
                                <b-th></b-th>
                            </b-thead>
                            <b-tbody>
                                <tr v-for="(si, i) in generated_si_codes" :key="i">
                                    <td>{{i + 1}}</td>
                                    <td>{{si.code}}</td>
                                    <td><a href="javascript:void(0)" @click="viewSO(si.code)">{{language_terms['VIEW']}}</a></td>
                                </tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                </b-row>
                <template #modal-footer="{ ok, cancel }">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button variant="primary" @click="routeToMain">
                  {{language_terms['CLOSE']}}
                </b-button>
              </template>
            </b-modal>

        </b-container>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import { mapState } from "vuex";
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import moment from "moment";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'


export default {
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms,
            business_units: (state) => state.customers.business_units,
            currencies: (state) => state.currencies.currencies,
            taxes: (state) => state.taxes.taxes,
            taxData: (state) => state.taxes.data,
            salesperson_list:state => state.employees.salesperson_list,
            auth_user:state => state.auth.auth_user,
            do_list_data: state => state.sales.do_list,
            generated_si_codes: state => state.sales.generated_si_codes
        })
    },
    components:{
        Loading,
        [Select.name]: Select,
        [Option.name]: Option,
        flatPicker,
        FormWizard,
        TabContent
    },
    watch:
    {
        do_list:{
            deep: true,
            // We have to move our method to a handler field
            handler()
            {
                let count = 0;
                for(let i = 0; i < this.do_list.length; i++)
                {
                    if(this.do_list[i].is_selected == 1)
                    {
                        count++
                    }
                }

                if(count == this.do_list.length)
                {
                    this.select_all = '1'
                }
                else
                {
                    this.select_all = '0'
                }

                this.selectedCount = count

            }
            
        }
    },
    data(){
        return{
            generate_si_modal:false,
            selectedCount:0,
            select_all:'0',
            selectMode: 'multi',
            do_list:[],
            fields: [
                { key: 'is_selected', label: 'SNO', name:'ok' },
                { key: 'code', label: 'DOCUMENT_NUMBER' },
                { key: 'movement_date', label: 'DATE' },
                { key: 'contact_name', label: 'CUSTOMER' },
                { key: 'reference_code', label: 'REFERENCE' },
                { key: 'salesperson_contact_id', label: 'SALESPERSON' },
                { key: 'actionsBtn', label: 'ACTION' },
            ],
            loading:false,
            customers:[],
            invoice:{
                revision_json:{},
                revision_id:null,
                time_printed:null,
                delivery_eta_days:null,
                action_edit:0,
                action_approval:0,
                require_approval:0,
                salesperson_contact_id:null,
                businessunit_contact_id:null,
                customer_credit_term:null,
                customer_credit_limit:null,
                customer_credit_limit_available:null,
                is_locked: false,
                is_approved: null,
                due_days: 30,
                due_date: null,
                tax_code: "",
                tax_rate_percent: null,
                contact_id: null,
                customer: {},
                currency_code: "SGD",
                remarks:"",
                remarks_internal:"",

            }
        }
    },
    async mounted(){

        await this.fetchCurrencies();
        await this.fetchTaxes();
        await this.fetchSalesPersons()
        await this.getAuthUser()

        if(this.auth_user)
        {
            if(this.invoice.date == '' || this.invoice.date == null)
            {
                this.invoice.date = moment().format("YYYY-MM-DD");
            }

            if(!this.invoice.salesperson_contact_id)
                this.invoice.salesperson_contact_id = this.auth_user.contact_id
        }

    },
    methods:
    {
        routeToMain()
        {
            this.$router.push("/sales/sales-invoices")

        },
        viewSO(code)
        {
            this.$router.push("/sales/sales-invoice/" + code)
        },
        onClickSelectAll()
        {
            //console.log(this.select_all)
           if(this.select_all == '1')
           {
               for(let i = 0; i < this.do_list.length; i++)
               {
                   this.do_list[i]['is_selected'] = 1
               }
           }
           else
           {
              for(let i = 0; i < this.do_list.length; i++)
               {
                   this.do_list[i]['is_selected'] = 0
               }
           }
        },
        makeToast(variant, message, toast_title) {
            this.$bvToast.toast(message, {
            title:toast_title,
            variant: variant,
            solid: true
            })
        },
        async generateInvoice()
        {
            if(this.selectedCount > 0)
            {
                let selected_dos = this.getSelectedDos()
                // console.log(selected_dos)


                await this.$store.dispatch("sales/generateInvoiceFromDo", 
                    {
                        contact_id:this.invoice.contact_id, 
                        date:this.invoice.date,
                        selected_dos:selected_dos
                    });
            
                console.log(this.generated_si_codes)

                if(this.generated_si_codes.length > 0)
                {
                    this.generate_si_modal = true
                    // for(let i = 0; i < this.generated_si_codes.length; i++)
                    // {
                    //     let path = "/sales/sales-invoice/" + this.generated_si_codes[i].code
                    //     let route = this.$router.resolve({path: path});
                    //     window.open(route.href, '_blank');
                    // }

                }
            }
            else
            {
                this.makeToast('warning', this.language_terms['NO_DO_SELECTED'], this.language_terms['ERROR'])
            }
        },
        getSelectedDos()
        {
            if(this.do_list.length > 0)
            {
                return this.do_list.filter(function(el) {
                    return el.is_selected == "1"
                })
            }
            else
            {
                return []
            }


        },
        async listDo()
        {
            if(this.invoice.contact_id && this.invoice.date)
            {
                this.isLoading = true
                await this.$store.dispatch("sales/fetchDosForSI", {contact_id:this.invoice.contact_id, date:this.invoice.date})
                this.do_list = this.do_list_data
                this.isLoading = false
            }
            else
            {
                alert("Please input customer & date")
            }
        },
        beforeStepChangeFirstTab()
        {
            let isValid = true

            return isValid
        },
        onComplete()
        {

        },
        async getAuthUser()
        {
            await this.$store.dispatch("auth/getAuthUser", {})
        },
        fetchSalesPersons() {
            this.$store.dispatch("employees/fetchAllSalesPerson", {"role_code":"sales person"});
        },
        fetchCurrencies() {
            this.$store.dispatch("currencies/fetchAll", {});
        },
        fetchTaxes() {
            this.$store.dispatch("taxes/fetchAll", { type: "Sales" });
        },
        async onChangeDate() 
        {
            if (this.invoice.date) 
            {
                if (this.invoice.tax_code)
                {
                    await this.retrieveRate(this.invoice.tax_code,this.invoice.date);
                    this.invoice.tax_rate_percent = this.taxData.rate_percent
                }

                this.onChangeValidityDays();
            }
        },
        async onChangeValidityDays() 
        {
            this.invoice.due_date = moment(this.invoice.date).add(this.invoice.due_days, "days").format("YYYY-MM-DD");
        },
        async onSelectCustomer(selectedOption)
        {
            if(selectedOption)
            {
                if(selectedOption.id)
                {
                    this.selected_business_unit = {id:""}
                    await this.$store.dispatch("customers/fetchBusinessUnits", {parent_id: selectedOption.id});

                if(this.business_units.length > 1)
                {
                    this.invoice.businessunit_contact_id = this.business_units[0].id
                    this.invoice.contact_id = selectedOption.id;
                }
                else
                {
                    this.invoice.contact_id = selectedOption.id;
                    this.invoice.tax_code = selectedOption.customer_tax_code;
                    this.invoice.currency_code = selectedOption.currency_code;
                    this.invoice.customer_credit_term = selectedOption.customer_credit_term;
                    this.invoice.customer_credit_limit = selectedOption.customer_credit_limit;
                    this.invoice.customer_credit_limit_available = selectedOption.customer_credit_limit_available;
                    this.invoice.attention_to = selectedOption.contact_person

                    await this.retrieveRate(this.invoice.tax_code, this.invoice.date)
                    this.invoice.tax_rate_percent = this.taxData.rate_percent

                    }

                }
            }
        },
        async asyncFindCustomer(query) 
        {
        let pv = { value: query };
        await axios.post(apiRoutes["CUSTOMER_LOOKUP"], pv, authHeader()).then((response) => {
            if (response.data.code == 1) {
                this.customers = response.data.data;
            } else {
                this.customers = [];
            }

            this.isLoading = false;
            })
            .catch((error) => {
            if (error.response) {
                console.log(error.response);
                Vue.notify({
                group: "notify",
                type: "error",
                text: error.response.data.msg,
                max: 5,
                duration: 5000,
                speed: 300,
                });
            } else {
                console.log("Problem submitting New Post", error);
            }
            });
        },
        async retrieveRate(code, date) 
        {
            await this.$store.dispatch("taxes/fetch", { code: code, date: date });
            this.invoice.tax_rate_percent = this.taxData.rate_percent;
        },
    }
}
</script>
